import { useTheme } from "../OAS365Theme";

export const useUploadFileRecords = () => {
  const theme = useTheme();
  const UploadFileRecordsStyle = {
    StackItemFileDetailStyles: stackItemNameSize(theme),
    StackMainStyles: stackMain(theme),
    StackItemMessageStyle: stackItemMessage(theme),
    StackItemRemoveButtonStyle: stackItemRemoveButton(theme),
    StackRemoveText : stackRemoveText(theme)
  };
  return UploadFileRecordsStyle;
};

const stackMain = (theme) => {
  const style = {
    root: {
      display: "flex",
      justifyContent: "start",
    },
  };
  return style;
};

const stackItemNameSize = (theme) => {
  const style = {
    root: {
      alignItems: "center",
      display: "flex",
      height: "auto",
      minHeight: 32,
      justifyContent: "start",
      overflow: "visible",
      paddingRight: "50px",
      color: theme.colors.fontColor,
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.normal,
      fontWeight: theme.fontWeight.titleWeight,
    },
  };
  return style;
};

const stackItemMessage = (theme) => {
  const style = {
    root: {
      alignItems: "center",
      display: "flex",
      height: "auto",
      minHeight: 32,
      justifyContent: "start",
      overflow: "visible",
      paddingRight: "50px",
      color: theme.colors.fontColor,
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.normal,
      fontWeight: theme.fontWeight.normal,
    },
  };
  return style;
};

const stackRemoveText = (theme) => {
  const style = {
    root: {
      color: theme.colors.themeDarkColor,
      fontFamily: `${theme.fonts.regular} !important`,
      fontSize: theme.fontSizes.menusize,
      fontWeight: theme.fontWeight.menuWeight,
    },
  };
  return style;
};

const stackItemRemoveButton = (theme) => {
  const style = {
    background: "transparent",
    border: "transparent",
    cursor: "pointer",
    color: theme.colors.themeDarkColor,
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    fontWeight: theme.fontWeight.menuWeight,
    root: {
      ".ms-Button-icon": {
        fontSize: theme.fontSizes.menusize,
        color: theme.colors.themeDarkColor,
        fontFamily: theme.fonts.regular,
      },
      ".ms-StackItem": {
        fontSize: theme.fontSizes.menusize,
        color: theme.colors.themeDarkColor,
        fontFamily: theme.fonts.regular,
      },
    },
    rootHovered: {
      background: "transparent",
      fontFamily: theme.fonts.regular,
    },
  };
  return style;
};
